import { render, staticRenderFns } from "./ResourceLimitTab.vue?vue&type=template&id=daf2e52c&scoped=true&"
import script from "./ResourceLimitTab.vue?vue&type=script&lang=js&"
export * from "./ResourceLimitTab.vue?vue&type=script&lang=js&"
import style0 from "./ResourceLimitTab.vue?vue&type=style&index=0&id=daf2e52c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf2e52c",
  null
  
)

export default component.exports